import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { EXTERNAL_PATHS, NEXT_STATIC_IMAGES, NEW_TAB_ATTRIBUTES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import styles from './Footer.module.scss';

const Footer: FC = () => {
  const [t] = useTranslation('safety-page');

  return (
    <PitchPageLayout backgroundColor="midnight01">
      <div className={styles.root}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={`${NEXT_STATIC_IMAGES}safety/footer-graphic.svg`}
          width={217}
          height={80}
          alt={t('footer--graphic--alt')}
          loading="lazy"
        />
        <div className={styles.title}>
          <Typography
            type="h3"
            size="display-5"
            sizeFromBreakpointM="display-4"
          >
            {t('footer--title')}
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            {t('footer--text')}
          </Typography>
        </div>
        <Button
          type="link"
          href={EXTERNAL_PATHS.JOURNAL}
          variant="primary-blue"
          fitWidth="m"
          {...NEW_TAB_ATTRIBUTES}
        >
          <Typography
            size="body-xl"
            type="p"
            weight="semibold"
          >
            {t('button--browse-articles')}
          </Typography>
        </Button>
      </div>
    </PitchPageLayout>
  );
};

export default Footer;
